import SoftwareProviders from './software-providers';

export default SoftwareProviders;
